<template>
	<div class="auto-image-wrapper">
		<div class="auto-image-wrapper__loader" v-if="isLoading" />
		<img
			:src="imageLink"
			:style="styles"
			loading="lazy"
			:class="classes"
			class="auto-image"
			@load="onImageLoad"
		/>
	</div>

</template>

<script>
// import {
// 	isMobile,
// } from '@/lib/helper';
import ImageSize from '@/lib/image-size';

export default {
	props: {
		path: String,
		classes: String,
		styles: {
			type: Object,
			default: () => {},
		},
		parentWidth: [String, Number],
		isOptimize: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			// parentWidth: 0,
			isLoading: true,
		};
	},
	components: {},
	computed: {
		imageLink() {
			let image = 'https://place-hold.it/200x200';
			if (this.path !== '') {
				if (this.isOptimize) {
					const imageSize = new ImageSize({
						path: this.path,
						// parentWidth: this.parentWidth,
					});
					image = imageSize.getLink();
				} else {
					image = this.path;
				}
			}
			return image;
		},
		imageStyle() {
			return this.styles ?? {};
		},
	},
	methods: {
		onImageLoad() {
			this.isLoading = false;
		},
	},
};
</script>

<style lang='scss'>
.font-icon {
	width: 15px;
	display: flex;
	align-items: center;
}

.auto-image-wrapper {
	display: inline-block;

	& > img {
		// position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		width: 100% !important;
		height: 100% !important;
	}

	&__loader {
		width: 200px;
		height: 200px;
		border: 1px solid #f5f5f5;
		background: #f5f5f5;

		&:after {
			content: " ";
			position: absolute;
			top: 50%;
			left: 50%;
			width: 30px;
			height: 30px;
			border: 4px solid #ddd;
			border-color: transparent #ddd transparent #ddd;
			border-radius: 50%;
			animation: loader 1s linear infinite;

			// content: '';
			// position: absolute;
			// top: 0;
			// left: 50%;
			// width: 200px;
			// height: 200px;
			// background: linear-gradient(to right, transparent 0%, #e1e1e1 85%, transparent 90%);
			// animation-duration: 1s;
			// animation-fill-mode: forwards;
			// animation-iteration-count: infinite;
			// animation-name: placeHolderShimmer;
			// animation-timing-function: linear;
		}
	}
}

@keyframes loader {
	0% {
		transform: translate(-50%,-50%) rotate(0deg);
	}
	100% {
		transform: translate(-50%,-50%) rotate(360deg);
	}
}

@keyframes placeHolderShimmer {
	0% {
		background-position: -468px 0
	}

	100% {
		background-position: 468px 0
	}
}


.auto-image {
	&:after {
		content: " ";
		// font-size: 16px;
		// font-family: FontAwesome;
		// color: rgb(100, 100, 100);
		// display: block;
		// position: absolute;
		// z-index: 2;
		// top: 0;
		// left: 0;
		// width: 100%;
		// height: 100%;
		// background-color: #fff;
	}
}
</style>
